import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Button, Modal, Form, Offcanvas } from 'react-bootstrap';
import ReactPaginate from 'react-paginate';
import { useAuth } from '../../../context/AuthContext';
import withPermission from '../../../utils/withPermission';
import Swal from 'sweetalert2';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const API_URL = `${backendUrl}/api/leave-types`;

const LeaveTypeList = () => {
    const [leaveType, setleaveType] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({ name: '' });
    const [isEdit, setIsEdit] = useState(false);
    const [selectedleavetype, setSelectedleavetype] = useState(null);
    const didFetchRef = useRef(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const WithListPermission = withPermission(({ children }) => children, ['type-list']);
    const WithCreatePermission = withPermission(({ children }) => children, ['leavetype-create']);
    const WithDeletePermission = withPermission(({ children }) => children, ['leavetype-delete']);
    const WithEditPermission = withPermission(({ children }) => children, ['leavetype-edit']);
    const [searchQuery, setSearchQuery] = useState('');
    const [errors, setErrors] = useState({});

    const debounceTimeoutRef = useRef(null);
    useEffect(() => {
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }

        debounceTimeoutRef.current = setTimeout(() => {
            fetchleaveType(1, searchQuery);
        }, searchQuery ? 1500 : 0);

        return () => {
            if (debounceTimeoutRef.current) {
                clearTimeout(debounceTimeoutRef.current);
            }
        };
    }, [searchQuery]);
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);

    };

    const fetchleaveType = async (page = 1) => {
        try {
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;
            const response = await axios.get(`${API_URL}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                params: {
                    page,
                    search: searchQuery,
                },
            });
            setleaveType(response.data?.data?.data || []);
            setPageCount(response.data.last_page);
            setCurrentPage(response.data.current_page);


        } catch (error) {
            console.error('Error fetching leaveType:', error);
        }
    };

    const handleAddleavetype = () => {
        setFormData({ name: '', description: '', is_paid: true,paid_ratio:'1.00' });
        setIsEdit(false);
        setSelectedleavetype(null);
        setShowModal(true);
    };

    const handleEditleavetype = (leavetype) => {
        setFormData(leavetype);
        setIsEdit(true);
        setSelectedleavetype(leavetype);
        setShowModal(true);
    };

    const handleDelete = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const userInfo = JSON.parse(localStorage.getItem('user-info'));
                    const origin = localStorage.getItem('user-origin');
                    const token = userInfo?.token;
                    await axios.delete(`${API_URL}/${id}`, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Tenant-Origin': origin,
                        },
                    });
                    setleaveType(leaveType.filter(leavetype => leavetype.id !== id));
                    Swal.fire(
                        "Deleted!",
                        "The leavetype has been deleted.",
                        "success"
                    );
                } catch (error) {
                    console.error('Error deleting leavetype:', error);
                    Swal.fire(
                        "Error!",
                        "Failed to delete leavetype. Please try again.",
                        "error"
                    );
                }
            }
        });

    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: "",  // Remove the error message for this field
        }));
    };

    const handlePageChange = ({ selected }) => {
        const newPage = selected + 1;
        setCurrentPage(newPage);
        fetchleaveType(newPage);
    };
    useEffect(() => {
        if (!showModal) {
            setErrors({});
        }
    }, [showModal]);

    const validateForm = () => {
    const newErrors = {};
    if (!formData.name?.trim()) {
        newErrors.name = 'Name is required';
    } else {
        const duplicateInstance = leaveType.some(
            (contact) =>
                contact?.name &&
                contact.name.toLowerCase() === formData.name.toLowerCase() &&
                contact.id !== (selectedleavetype?.id || null)
        );

        if (duplicateInstance) {
            newErrors.name = 'Name must be unique';
        }
    }

    return newErrors;
};

    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        const userInfo = JSON.parse(localStorage.getItem('user-info'));
        const origin = localStorage.getItem('user-origin');
        const token = userInfo?.token;
        const validationErrors = validateForm();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            setLoading(false);
            return; // Stop here if validation fails
        }
        try {
            if (isEdit) {
                const response = await axios.put(`${API_URL}/${selectedleavetype.id}`, formData, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                });
                setleaveType(leaveType.map(ind => (ind.id === selectedleavetype.id ? response.data.data : ind)));
            } else {
                const response = await axios.post(API_URL, formData, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                });
                setleaveType([...leaveType, response.data.data]);
            }
            setShowModal(false);
        } catch (error) {
            console.error('Error saving leavetype:', error);
        }
    };

    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid ">
                    <div className="row w-100">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0 font-size-18">Leave Type</h4>
                                <div className="page-title-right">

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="d-flex justify-content-between mb-3">
                                        <div className="d-flex">
                                            <div className="search-box me-2 mb-2 d-inline-block">
                                                <div className="position-relative">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Search..."
                                                        value={searchQuery}
                                                        onChange={handleSearchChange}
                                                    />
                                                    <i className="bx bx-search-alt search-icon" />
                                                </div>
                                            </div>



                                        </div>
                                        <WithCreatePermission>
                                            <button
                                                type="button"
                                                className="btn rounded-circle border d-flex align-items-center justify-content-center round-create-button"

                                                onClick={handleAddleavetype}
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title='Add leavetype'
                                            >
                                                <i className="mdi mdi-plus" ></i>
                                            </button></WithCreatePermission>
                                    </div>
                                    <table className="table align-middle table-nowrap table-check table-list">

                                        <thead className="table-sales-gradient">
                                            <tr>
                                                <th style={{ width: '20px' }} className="align-middle">
                                                    <div className="form-check font-size-16">
                                                        <input className="form-check-input" type="checkbox" id="checkAll" />
                                                        <label className="form-check-label" htmlFor="checkAll"></label>
                                                    </div>
                                                </th>
                                                <th className="align-middle">#</th>
                                                <th className="align-middle"> Name</th>
                                                <th className="align-middle"> description</th>

                                                <th className="align-middle">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {leaveType.map((leavetype, index) => (
                                                <tr key={leavetype.id}>
                                                    <td>
                                                        <div className="form-check font-size-16">
                                                            <input
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                id={`instanceCheck${index}`}
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor={`instanceCheck${index}`}
                                                            ></label>
                                                        </div>
                                                    </td>
                                                    <td>{index + 1}</td>
                                                    <td>{leavetype.name}</td>
                                                    <td>{leavetype.description}</td>

                                                    <td>
                                                        <div className="dropdown">
                                                            <i
                                                                className="mdi mdi-dots-horizontal font-size-18"
                                                                data-bs-toggle="dropdown"
                                                                aria-expanded="false"
                                                                style={{ cursor: 'pointer' }}
                                                            ></i>
                                                            <ul className="dropdown-menu dropdown-menu-end font-size-14">
                                                                <li>
                                                                    <WithEditPermission>
                                                                        <button className="dropdown-item" onClick={() => handleEditleavetype(leavetype)}>
                                                                            Edit
                                                                        </button>
                                                                    </WithEditPermission>
                                                                </li>
                                                                <li>
                                                                    <WithDeletePermission>
                                                                        <button className="dropdown-item" onClick={() => handleDelete(leavetype.id)}>
                                                                            Delete
                                                                        </button>
                                                                    </WithDeletePermission>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <div className="d-flex justify-content-end pagination-sm">
                                        <ReactPaginate
                                            previousLabel={'<'}
                                            nextLabel={'>'}
                                            breakLabel={'...'}
                                            pageCount={pageCount}
                                            marginPagesDisplayed={2}
                                            pageRangeDisplayed={3}
                                            onPageChange={handlePageChange}
                                            containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
                                            pageClassName={'page-item'}
                                            pageLinkClassName={'page-link'}
                                            previousClassName={'page-item previous'}
                                            previousLinkClassName={'page-link'}
                                            nextClassName={'page-item next'}
                                            nextLinkClassName={'page-link'}
                                            breakClassName={'page-item'}
                                            breakLinkClassName={'page-link'}
                                            activeClassName={'active'}
                                        />
                                    </div>
                                    {/* Modal for Add/Edit leavetype */}
                                    <Offcanvas show={showModal} onHide={() => setShowModal(false)} placement='end'>
                                        <Offcanvas.Header closeButton>
                                            <Offcanvas.Title>{isEdit ? 'Edit Leave Type' : 'Add Leave Type'}</Offcanvas.Title>
                                        </Offcanvas.Header>
                                        <hr style={{ margin: 0 }} /><br />

                                        <Offcanvas.Body>
                                            <Form>
                                                <Form.Group controlId="leavetypeName" className='mb-3'>
                                                    <Form.Label style={{ fontSize: "13px" }}>Name</Form.Label>
                                                    <Form.Control type="text" style={{ fontSize: "13px" }} name="name" value={formData.name} onChange={handleInputChange}
                                                        className={`form-control ${errors?.name ? 'is-invalid' : ''}`}

                                                    />
                                                    {errors.name && <div className="invalid-feedback" style={{ fontSize: '12px' }}>*{errors.name}</div>}
                                                </Form.Group><br />
                                                <Form.Group controlId="description" className="mb-3">
                                                    <Form.Label style={{ fontSize: "13px" }}>Description</Form.Label>
                                                    <Form.Control
                                                        as="textarea"
                                                        rows={3} // you can change rows for height
                                                        style={{ fontSize: "13px" }}
                                                        name="description"
                                                        value={formData.description}
                                                        onChange={handleInputChange}
                                                        className="form-control"
                                                    />
                                                </Form.Group>
                                                  <Form.Group controlId="isDeferred" className="mb-3">
                                                                                                    <Form.Check
                                                                                                        type="checkbox"
                                                                                                        label="Paid Leave"
                                                                                                        checked={formData.is_paid}
                                                                                                        onChange={(e) =>
                                                                                                            setFormData(prev => ({ ...prev, is_paid: e.target.checked }))
                                                                                                        }
                                                                                                        style={{ fontSize: '13px' }}
                                                                                                    />
                                                                                                </Form.Group>
                                                                                                  <Form.Group controlId="paid_ratio" className="mb-3">
                                                    <Form.Label style={{ fontSize: "13px" }}>Paid Ratio</Form.Label>
                                                    <Form.Control
                                                      type='number'
                                                        style={{ fontSize: "13px" }}
                                                        name="paid_ratio"
                                                        value={formData.paid_ratio}
                                                        onChange={handleInputChange}
                                                        className="form-control"
                                                    />
                                                </Form.Group>

                                            </Form>
                                        </Offcanvas.Body>
                                        <div className="p-3 d-flex justify-content-end border-top">
                                            <Button variant="secondary me-2" onClick={() => setShowModal(false)}>Close</Button>
                                            <Button variant="primary" onClick={handleSubmit}>{isEdit ? 'Update' : 'Save'} </Button>
                                        </div>
                                    </Offcanvas>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LeaveTypeList;
